import StringExpression, { sanitiseInput } from './StringExpression';
import isNil from 'lodash/isNil';

export default class MembershipStringExpression {
    private expr: StringExpression[];

    public constructor(target: string[]) {
        this.expr = target.map((t) => new StringExpression(t));
    }

    public testIsOneOf(source: string) {
        if (isNil(source)) {
            return false;
        }
        return this.expr.some((e) => e.testIsEqual(source));
    }

    public testNotIsOneOf(source: string) {
        return !this.testIsOneOf(source);
    }

    public testContainsOneOf(source: string) {
        if (isNil(source)) {
            return false;
        }
        return this.expr.some((e) => e.testContains(source));
    }

    public testNotContainsOneOf(source: string) {
        return !this.testContainsOneOf(source);
    }

    public testStartsWithOneOf(source: string) {
        if (isNil(source)) {
            return false;
        }
        return this.expr.some((e) => e.testStartsWith(source));
    }

    public testEndsWithOneOf(source: string) {
        if (isNil(source)) {
            return false;
        }
        return this.expr.some((e) => e.testEndsWith(source));
    }

    public testBlankOneOf(source: string) {
        // This sign does not have a value to compare against...
        if (isNil(source)) {
            return true;
        }

        return sanitiseInput(source) === '';
    }

    public testNotBlankOneOf(source: string) {
        return !this.testBlankOneOf(source);
    }
}
